import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }

export function render(_ctx, _cache) {
  const _component_v_col = _resolveComponent("v-col")
  const _component_v_spacer = _resolveComponent("v-spacer")
  const _component_MonthlyReportDialog = _resolveComponent("MonthlyReportDialog")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_card_title = _resolveComponent("v-card-title")
  const _component_MonthlyReportContent = _resolveComponent("MonthlyReportContent")
  const _component_v_card_text = _resolveComponent("v-card-text")
  const _component_v_card = _resolveComponent("v-card")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "mb-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Monthly report preview ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "9",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_MonthlyReportDialog, {
                          visible: _ctx.englishDialogVisible,
                          "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.englishDialogVisible) = $event)),
                          buttonSignature: "Edit English part",
                          header: "Email content",
                          mainContent: _ctx.englishContent,
                          templateSignature: _ctx.englishSignature,
                          onSave: _ctx.saveEnglishContent
                        }, null, 8, ["visible", "mainContent", "templateSignature", "onSave"]),
                        _createVNode(_component_MonthlyReportDialog, {
                          class: "pr-2",
                          visible: _ctx.germanDialogVisible,
                          "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.germanDialogVisible) = $event)),
                          buttonSignature: "Edit German part",
                          header: "Email content",
                          mainContent: _ctx.germanContent,
                          templateSignature: _ctx.germanSignature,
                          onSave: _ctx.saveGermanContent
                        }, null, 8, ["visible", "mainContent", "templateSignature", "onSave"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_MonthlyReportContent, {
              germanContent: _ctx.germanContent,
              germanSignature: _ctx.germanSignature,
              englishContent: _ctx.englishContent,
              englishSignature: _ctx.englishSignature
            }, null, 8, ["germanContent", "germanSignature", "englishContent", "englishSignature"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}